module.exports = new __parcel__URL__("user-brand-light.00eefa28.svg").toString();